var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7h12M6 1l6 6-6 6",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};

export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgN0wxMiA3IiBzdHJva2U9IiNGNEY0RjQiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNiAxTDEyIDdMNiAxMyIgc3Ryb2tlPSIjRjRGNEY0IiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";